<app-navbar></app-navbar>
<app-blockly></app-blockly>
<mat-toolbar color="primary" class="footer">
  <span style="text-align: left;width: 50%;" id="copyright">{{ 'CocoRobo LTD © 2023 Copyright' | translate }}</span>
  <span style="text-align: right;width: 50%;" id = "sign">{{ 'Coco AI Blockly' | translate }}</span>
</mat-toolbar>
